import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const settlements = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.PENDING_SETTLEMENT:
      return { ...state, pendingSettlements: action.value };
    case actions.SETTLED_SETTLEMENT:
      return { ...state, settledSettlements: action.value };
    case actions.SETTLEMENT_SUMMARY:
      return { ...state, settlementSummary: action.value };
    case actions.SETTLEMENT_LEDGER:
      return { ...state, settlementLedger: action.value };
    case actions.CURRENTDUE_VEHICLES:
      return { ...state, currentDueVehicles: action.value };
    case actions.PREVIOUS_SETTLEMENT:
      return { ...state, previousSettlements: action.value };
    case actions.SETTLEMENT_UPLOAD:
      return { ...state, settlementUploadSheet: action.value };
    case actions.SETTLEMENT_UPLOAD_FAILURE:
      return { ...state, settlementUploadSheetError: action.value };
    default:
      return state;
  }
};

export default settlements;
